import Repository, {
  ExtendedAxiosRequestConfig,
} from "@shared/services/api/abstracts/Repository";
import { UrlRouteMap } from "@shared/services/api/types";
import { JwtPayload, JwtSerializer } from "./serializer-types";

type RefreshTokenResponse = { pk: number; token: string };
export class AuthJwtRepository extends Repository<JwtSerializer> {
  public readonly repositoryName = "AuthJwtRepository";

  public readonly endpoint = "api/auth/jwt";

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      createToken: "/",
      refresh: "refresh",
      verify: "verify",
    };
  }

  /**
   * Define and override the default `create` url
   * since the payload type is different than the return type
   */
  public async createToken(
    attributes?: JwtPayload,
    config: ExtendedAxiosRequestConfig = {}
  ): Promise<JwtSerializer> {
    const { data } = await this.request(this.buildUrl("createToken"), {
      method: "post",
      data: attributes,
      ...config,
    });

    return data;
  }

  public async refresh(token: string): Promise<RefreshTokenResponse> {
    const { data } = await this.request<RefreshTokenResponse>(
      this.buildUrl("refresh"),
      {
        method: "POST",
        data: { token },
      }
    );
    return data;
  }

  public async verify(token: string) {
    const { data } = await this.request(this.buildUrl("verify"), {
      method: "POST",
      data: { token },
    });
    return data;
  }
}
